<template>
  <header class="header" :class="{ scrolled: isScrolled }">
    <div class="header-content">
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" />
      </div>
      <div class="header-right">
        <ul class="nav">
          <li>首页</li>
          <li>产品系列</li>
          <li>服务优势</li>
          <li>新闻资讯</li>
          <li>关于跃动</li>
          <li>加入我们</li>
        </ul>
        <div class="function">
          <div class="search-icon">
            <i class="el-icon-search"></i>
          </div>
          <div class="lang">EN</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isScrolled: false,
    };
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 获取 box1 元素的高度
      const box1 = document.querySelector(".box1");
      if (box1) {
        const box1Height = box1.offsetHeight;
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        this.isScrolled = scrollTop > box1Height;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  .header-content {
    width: 100%;
    height: 79px;
    padding: 0 90px 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    transition: background-color 0.3s ease;
    .logo {
      width: 91px;
      height: 69px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      height: 100%;
      .nav {
        display: flex;
        gap: 75px;
        margin-right: 200px;
        height: 100%;
        li {
          list-style: none;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #fff;
          position: relative;
          cursor: pointer;
          padding-bottom: 25px;
          box-sizing: border-box;
          display: flex;
          align-items: flex-end;
          transition: color 0.3s ease;
          &:hover {
            color: #121212;
            &::after {
              content: "";
              position: absolute;
              bottom: 0px;
              left: 50%;
              transform: translateX(-50%);
              width: 75px;
              height: 2px;
              background: linear-gradient(90deg, #0643bf 0%, #1d8bfd 100%);
              border-radius: 0px 0px 0px 0px;
            }
          }
        }
      }
      .function {
        display: flex;
        .search-icon,
        .lang {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: 1px solid #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          transition: color 0.3s ease, border-color 0.3s ease;
        }
        .search-icon {
          margin-right: 20px;
          i {
            font-size: 18px;
            color: #fff;
            transition: color 0.3s ease;
          }
        }
      }
    }
    // hover 时的样式（只在未滚动时生效）
    &:hover {
      background: #ffffff;
      .header-right {
        .nav {
          li {
            color: #666666;
          }
        }
        .function {
          .search-icon,
          .lang {
            border: 1px solid #666666;
            color: #666666;
          }
          .search-icon {
            i {
              color: #666666;
            }
          }
        }
      }
    }
  }
  // 滚动超过 box1 时的样式
  &.scrolled {
    .header-content {
      background: #ffffff;
      .header-right {
        .nav {
          li {
            color: #666666;
          }
        }
        .function {
          .search-icon,
          .lang {
            border: 1px solid #666666;
            color: #666666;
          }
          .search-icon {
            i {
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
